import { ContentSection, DataOverview, DescriptionList } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";
import { getDefaultMonthlyPayment } from "../../data/contract";
import { BrandType } from "@bus/models";
import { capitalizeBrand } from "../../helpers/capitalizeBrand";

export const FinancialInformation = () => {
    const { t } = useTranslation(["summarypage"]);

    const { goToQuestionsStep, submitAnswersRequest } = useMatchMakerWizard();
    const { matchMakerAnswers } = submitAnswersRequest;
    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    const getTitle = () => {
        switch (brand as BrandType) {
            case BrandType.VWN:
                return t("summarypage:financial-information.titleVWN")
            case BrandType.VW:
                return t("summarypage:financial-information.titleVW")
            default:
                return t("summarypage:financial-information.title", {
                    brand: capitalizeBrand(brand as BrandType),
                })
        }
    }

    return (
        <ContentSection.ComponentWrapper>
            <DataOverview
                href=""
                titleLevel={2}
                title={getTitle()}
                buttonLabel={t("summarypage:edit")}
                buttonProps={{
                    id: "FinancialInformationSummaryEditButton",
                    onClick: (e) => {
                        e.preventDefault();
                        goToQuestionsStep(2, true);
                    },
                    tabIndex: 0,
                }}
                id="FinancialInformationSummary"
            >
                {matchMakerAnswers && (
                    <DescriptionList grid>
                        <DescriptionList.Group termText={t("summarypage:financial-information.monthly-budget")}>
                            <DescriptionList.Detail id="FinancialInformationMonthlyBudget">
                                {matchMakerAnswers.monthlyPayment
                                    ? parseInt(matchMakerAnswers.monthlyPayment.toString() ?? 0)
                                    : getDefaultMonthlyPayment().toFixed(0)}{" "}
                                €
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                        <DescriptionList.Group termText={t("summarypage:financial-information.deposit")}>
                            <DescriptionList.Detail id="FinancialInformationDeposit">
                                {matchMakerAnswers.deposit && matchMakerAnswers.deposit > 0
                                    ? matchMakerAnswers.deposit
                                    : 0}{" "}
                                €
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                        <DescriptionList.Group termText={t("summarypage:financial-information.duration")}>
                            <DescriptionList.Detail id="FinancialInformationDuration">
                                {matchMakerAnswers.duration} {t("summarypage:months")}
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                    </DescriptionList>
                )}
            </DataOverview>
        </ContentSection.ComponentWrapper>
    );
};
